export default __webpack_public_path__ + "static/media/MilkTeaPouring1.9a6f15d8.jpg";